// import React, { useState, useRef, useEffect } from 'react';
// import { 
//   Box, 
//   Typography, 
//   Container, 
//   useTheme, 
//   styled 
// } from '@mui/material';
// import { motion, useInView } from 'framer-motion';

// // Styled components with framer-motion integration
// const MainCircle = styled(motion.div)(({ theme }) => ({
//   width: '100%',
//   height: 0,
//   paddingBottom: '100%', // Makes it a perfect circle
//   borderRadius: '50%',
//   position: 'relative',
//   backgroundColor: '#333333',
//   border: '8px solid #f6a035',
//   boxShadow: 'none',
//   overflow: 'hidden',
//   backgroundImage: 'url("Matt Image111.jpg")', // Placeholder image - replace with your actual image URL
//   backgroundSize: 'cover',
//   backgroundPosition: 'center',
//   '&::before': {
//     content: '""',
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     width: '100%',
//     height: '100%',
//     backgroundColor: 'rgba(53, 61, 82, 0.8)', // Semi-transparent overlay for readability
//   }
// }));

// const CircleContent = styled(motion.div)(({ theme }) => ({
//   position: 'absolute',
//   top: '50%',
//   left: '50%',
//   transform: 'translate(-50%, -50%)',
//   width: '80%',
//   textAlign: 'center',
//   color: 'white',
//   zIndex: 1, // Ensure content is above the overlay
//   [theme.breakpoints.down('sm')]: {
//     width: '90%',
//     // Hide the second paragraph on smaller screens
//     '& p:nth-of-type(2)': {
//       display: 'none'
//     }
//   }
// }));

// // New component for mobile-only paragraph that will display below the circle
// const MobileOnlyText = styled(motion.div)(({ theme }) => ({
//   display: 'none', // Hidden by default
//   textAlign: 'center',
//   color: '#172554',
//   marginTop: theme.spacing(3),
//   marginBottom: theme.spacing(3),
//   padding: theme.spacing(2),
//   backgroundColor: 'rgba(249, 115, 22, 0.1)',
//   borderRadius: theme.spacing(1),
//   [theme.breakpoints.down('md')]: {
//     display: 'block' // Show only on mobile
//   }
// }));

// const ServiceItem = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   marginBottom: theme.spacing(5),
//   position: 'relative',
// }));

// const ServiceBar = styled(motion.div)(({ theme }) => ({
//   backgroundColor: '#172554',
//   borderRadius: '30px',
//   padding: theme.spacing(2, 4),
//   color: 'white',
//   flexGrow: 1,
//   display: 'flex',
//   alignItems: 'center',
//   height: '60px',
//   originX: 0,
//   [theme.breakpoints.down('sm')]: {
//     padding: theme.spacing(2, 2),
//     '& p': {
//       fontSize: '14px'
//     }
//   }
// }));

// const NumberCircle = styled(motion.div)(({ theme }) => ({
//   width: '70px',
//   height: '70px',
//   borderRadius: '50%',
//   backgroundColor: '#172554',
//   border: '4px solid #f6a035',
//   color: 'white',
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   fontSize: '32px',
//   fontWeight: 'bold',
//   position: 'relative',
//   zIndex: 2,
//   [theme.breakpoints.down('sm')]: {
//     width: '60px',
//     height: '60px',
//     fontSize: '28px'
//   }
// }));

// // Main component
// const ThesisChaptersWriting: React.FC = () => {
//   const theme = useTheme();
//   const [circleAnimationComplete, setCircleAnimationComplete] = useState(false);
//   const [numbersAnimationComplete, setNumbersAnimationComplete] = useState(false);
  
//   // Ref for the entire component to check when it enters viewport
//   const componentRef = useRef<HTMLDivElement>(null);
//   const isInView = useInView(componentRef, { once: true, amount: 0.3 });
  
//   // Service data
//   const services = [
//     { 
//       id: 1, 
//       text: "Grammar, punctuation, and spelling corrections" 
//     },
//     { 
//       id: 2, 
//       text: "Sentence restructuring for better readability" 
//     },
//     { 
//       id: 3, 
//       text: "Consistency in tone, style, and formatting" 
//     },
//     { 
//       id: 4, 
//       text: "Plagiarism check and citation verification" 
//     }
//   ];

//   // Animation variants
//   const mainCircleVariants = {
//     hidden: { scale: 0, opacity: 0 },
//     visible: { 
//       scale: 1, 
//       opacity: 1,
//       transition: { 
//         duration: 1.2,
//         ease: "easeOut"
//       }
//     }
//   };

//   const circleContentVariants = {
//     hidden: { opacity: 0 },
//     visible: { 
//       opacity: 1,
//       transition: { 
//         delay: 0.7,
//         duration: 0.8 
//       }
//     }
//   };

//   const mobileTextVariants = {
//     hidden: { opacity: 0, y: 20 },
//     visible: { 
//       opacity: 1,
//       y: 0,
//       transition: { 
//         delay: 0.9,
//         duration: 0.6 
//       }
//     }
//   };

//   const numberCircleVariants = {
//     hidden: { scale: 0, opacity: 0 },
//     visible: (custom: number) => ({
//       scale: 1,
//       opacity: 1,
//       transition: {
//         delay: custom * 0.15, // Staggered delay between circles
//         duration: 0.6,
//         ease: "easeOut"
//       }
//     })
//   };

//   const serviceBarVariants = {
//     hidden: { scaleX: 0, opacity: 0, originX: 0 },
//     visible: (custom: number) => ({
//       scaleX: 1,
//       opacity: 1,
//       transition: {
//         delay: custom * 0.15, // Match the stagger timing of the circles
//         duration: 0.7,
//         ease: "easeOut"
//       }
//     })
//   };

//   const handleCircleAnimationComplete = () => {
//     setCircleAnimationComplete(true);
//   };

//   const handleNumbersAnimationComplete = (index: number) => {
//     if (index === services.length - 1) {
//       setNumbersAnimationComplete(true);
//     }
//   };

//   return (
//     <Container ref={componentRef} maxWidth="lg" sx={{ py: 8 }}>
//       <Typography 
//         variant="h5" 
//         fontWeight={600} 
//         gutterBottom 
//         textAlign={"center"}
//         color={"#172554"}
//         sx={{ fontSize: { xs: "20px", sm: "24px", md: "28px" } }}
//       >
//         Professional{" "}
//         <span
//           style={{
//             background:
//               "linear-gradient(-96deg, rgb(255 255 255 / 0%) 0%, rgb(255 249 220 / 0%) 28%, rgb(253, 103, 16) 100%, rgb(255 255 255 / 0%) 100%)",
//             padding: "0px 5px",
//           }}
//         >
//           Editing & Proofreading
//         </span>{" "}Services
//       </Typography>
//       <Box sx={{ 
//         display: 'flex', 
//         flexDirection: { xs: 'column', md: 'row' },
//         alignItems: 'center',
//         position: 'relative'
//       }}>
//         {/* Left Circle */}
//         <Box sx={{ 
//           width: { xs: '80%', sm: '70%', md: '40%' },
//           position: 'relative',
//           mb: { xs: 4, md: 0 }
//         }}>
//           <MainCircle
//             initial="hidden"
//             animate={isInView ? "visible" : "hidden"}
//             variants={mainCircleVariants}
//             onAnimationComplete={handleCircleAnimationComplete}
//           >
//             <CircleContent
//               initial="hidden"
//               animate={isInView ? "visible" : "hidden"}
//               variants={circleContentVariants}
//             >
//               <Typography variant="body1" sx={{ fontSize: { xs: '14px', sm: '16px' }, mb: 2 }}>
//                 Our expert editors refine your dissertation to ensure clarity, coherence, and logical flow. We enhance sentence structure, grammar, and vocabulary to maintain academic excellence.
//               </Typography>
//               <Typography variant="body1" sx={{ fontSize: { xs: '14px', sm: '16px' } }}>
//                 We also ensure adherence to academic style guides such as APA, MLA, Harvard, and Chicago. Our team checks citations, references, and overall formatting to meet university guidelines.
//               </Typography>
//             </CircleContent>
//           </MainCircle>
          
//           {/* Mobile-only text that appears below the circle */}
//           <MobileOnlyText
//             initial="hidden"
//             animate={isInView ? "visible" : "hidden"}
//             variants={mobileTextVariants}
//           >
//             <Typography variant="body1" sx={{ fontSize: '16px' }}>
//               We also ensure adherence to academic style guides such as APA, MLA, Harvard, and Chicago. Our team checks citations, references, and overall formatting to meet university guidelines, improving readability and presentation.
//             </Typography>
//           </MobileOnlyText>
//         </Box>
        
//         {/* Right Service Items */}
//         <Box sx={{ 
//           width: { xs: '100%', md: '60%' },
//           pl: { md: 8 }, 
//           position: 'relative',
//           mt: { xs: 2, md: 0 }
//         }}>
//           {services.map((service, index) => {
//             // Adjusted for better spacing on mobile
//             const itemPosition = index === 0 ? { xs: '0%', md: '12%' } : 0;
            
//             return (
//               <ServiceItem key={service.id} sx={{ 
//                 mt: index === 0 ? itemPosition : 0, 
//                 mb: { xs: 3, md: 5 }
//               }}>
//                 {/* Number Circle with animation */}
//                 <NumberCircle
//                   initial="hidden"
//                   animate={(isInView && circleAnimationComplete) ? "visible" : "hidden"}
//                   variants={numberCircleVariants}
//                   custom={index}
//                   onAnimationComplete={() => handleNumbersAnimationComplete(index)}
//                 >
//                   {service.id}
//                 </NumberCircle>
                
//                 {/* Service Bar with animation */}
//                 <ServiceBar 
//                   initial="hidden"
//                   animate={(isInView && numbersAnimationComplete) ? "visible" : "hidden"}
//                   variants={serviceBarVariants}
//                   custom={index}
//                   sx={{ ml: -2 }}
//                 >
//                   <Typography>{service.text}</Typography>
//                 </ServiceBar>
//               </ServiceItem>
//             );
//           })}
//         </Box>
//       </Box>
//     </Container>
//   );
// };

// export default ThesisChaptersWriting;






import React, { useState, useRef, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  Container, 
  useTheme, 
  styled 
} from '@mui/material';
import { motion, useInView } from 'framer-motion';

// Styled components with framer-motion integration
const MainCircle = styled(motion.div)(({ theme }) => ({
  width: '100%',
  height: 0,
  paddingBottom: '100%', // Makes it a perfect circle
  borderRadius: '50%',
  position: 'relative',
  backgroundColor: '#333333',
  border: '8px solid #f6a035',
  boxShadow: 'none',
  overflow: 'hidden',
  backgroundImage: 'url("Matt Image111.jpg")', // Placeholder image - replace with your actual image URL
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(53, 61, 82, 0.8)', // Semi-transparent overlay for readability
  }
}));

const CircleContent = styled(motion.div)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  textAlign: 'center',
  fontWeight: 600 ,
  color: 'white',
  zIndex: 1, // Ensure content is above the overlay
  [theme.breakpoints.down('sm')]: {
    width: '90%',
    // Hide the second paragraph on smaller screens
    '& p:nth-of-type(2)': {
      display: 'none'
    }
  }
}));

// Modified MobileOnlyText to never display
const MobileOnlyText = styled(motion.div)(({ theme }) => ({
  display: 'none', // Hidden on all screen sizes
}));

const ServiceItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(5),
  position: 'relative',
}));

const ServiceBar = styled(motion.div)(({ theme }) => ({
  backgroundColor: '#172554',
  borderRadius: '30px',
  padding: theme.spacing(2, 4),
  color: 'white',
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  height: '60px',
  originX: 0,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2, 2),
    '& p': {
      fontSize: '16px'
    }
  }
}));

const NumberCircle = styled(motion.div)(({ theme }) => ({
  width: '70px',
  height: '70px',
  borderRadius: '50%',
  backgroundColor: '#172554',
  border: '4px solid #f6a035',
  color: 'white',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '32px',
  fontWeight: 'bold',
  position: 'relative',
  zIndex: 2,
  [theme.breakpoints.down('sm')]: {
    width: '60px',
    height: '60px',
    fontSize: '28px'
  }
}));

// Main component
const DessertationProofReading: React.FC = () => {
  const theme = useTheme();
  const [circleAnimationComplete, setCircleAnimationComplete] = useState(false);
  const [numbersAnimationComplete, setNumbersAnimationComplete] = useState(false);
  
  // Ref for the entire component to check when it enters viewport
  const componentRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(componentRef, { once: true, amount: 0.3 });
  
  // Service data
  const services = [
    { 
      id: 1, 
      text: "Grammar, punctuation, and spelling corrections" 
    },
    { 
      id: 2, 
      text: "Sentence restructuring for better readability" 
    },
    { 
      id: 3, 
      text: "Consistency in tone, style, and formatting" 
    },
    { 
      id: 4, 
      text: "Plagiarism check and citation verification" 
    }
  ];

  // Animation variants
  const mainCircleVariants = {
    hidden: { scale: 0, opacity: 0 },
    visible: { 
      scale: 1, 
      opacity: 1,
      transition: { 
        duration: 1.2,
        ease: "easeOut"
      }
    }
  };

  const circleContentVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { 
        delay: 0.7,
        duration: 0.8 
      }
    }
  };

  const mobileTextVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1,
      y: 0,
      transition: { 
        delay: 0.9,
        duration: 0.6 
      }
    }
  };

  const numberCircleVariants = {
    hidden: { scale: 0, opacity: 0 },
    visible: (custom: number) => ({
      scale: 1,
      opacity: 1,
      transition: {
        delay: custom * 0.15, // Staggered delay between circles
        duration: 0.6,
        ease: "easeOut"
      }
    })
  };

  const serviceBarVariants = {
    hidden: { scaleX: 0, opacity: 0, originX: 0 },
    visible: (custom: number) => ({
      scaleX: 1,
      opacity: 1,
      transition: {
        delay: custom * 0.15, // Match the stagger timing of the circles
        duration: 0.7,
        ease: "easeOut"
      }
    })
  };

  const handleCircleAnimationComplete = () => {
    setCircleAnimationComplete(true);
  };

  const handleNumbersAnimationComplete = (index: number) => {
    if (index === services.length - 1) {
      setNumbersAnimationComplete(true);
    }
  };

  return (
    <Container ref={componentRef} maxWidth="lg" sx={{ py: 8 }}>
      <Typography 
        variant="h5" 
        fontWeight={600} 
        gutterBottom 
        textAlign={"center"}
        color={"#172554"}
        sx={{ fontSize: { xs: "20px", sm: "24px", md: "28px" } }}
      >
        Professional{" "}
        <span
          style={{
            background:
              "linear-gradient(-96deg, rgb(255 255 255 / 0%) 0%, rgb(255 249 220 / 0%) 28%, rgb(253, 103, 16) 100%, rgb(255 255 255 / 0%) 100%)",
            padding: "0px 5px",
          }}
        >
          Editing & Proofreading
        </span>{" "}Services
      </Typography>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        position: 'relative'
      }}>
        {/* Left Circle */}
        <Box sx={{ 
          width: { xs: '80%', sm: '70%', md: '40%' },
          position: 'relative',
          mb: { xs: 4, md: 0 }
        }}>
          <MainCircle
            initial="hidden"
            animate={isInView ? "visible" : "hidden"}
            variants={mainCircleVariants}
            onAnimationComplete={handleCircleAnimationComplete}
          >
            <CircleContent
              initial="hidden"
              animate={isInView ? "visible" : "hidden"}
              variants={circleContentVariants}
            >
              <Typography variant="body1" sx={{ fontSize: { xs: '14px', sm: '16px' }, mb: 2 }}>
                Our expert editors refine your dissertation to ensure clarity, coherence, and logical flow. We enhance sentence structure, grammar, and vocabulary to maintain academic excellence.
              </Typography>
              <Typography variant="body1" sx={{ fontSize: { xs: '14px', sm: '16px' } }}>
                We also ensure adherence to academic style guides such as APA, MLA, Harvard, and Chicago. Our team checks citations, references, and overall formatting to meet university guidelines.
              </Typography>
            </CircleContent>
          </MainCircle>
          
          {/* Mobile-only text - now always hidden */}
          <MobileOnlyText
            initial="hidden"
            animate={isInView ? "visible" : "hidden"}
            variants={mobileTextVariants}
          >
            <Typography variant="body1" sx={{ fontSize: '16px' }}>
              We also ensure adherence to academic style guides such as APA, MLA, Harvard, and Chicago. Our team checks citations, references, and overall formatting to meet university guidelines, improving readability and presentation.
            </Typography>
          </MobileOnlyText>
        </Box>
        
        {/* Right Service Items */}
        <Box sx={{ 
          width: { xs: '100%', md: '60%' },
          pl: { md: 8 }, 
          position: 'relative',
          mt: { xs: 2, md: 0 }
        }}>
          {services.map((service, index) => {
            // Adjusted for better spacing on mobile
            const itemPosition = index === 0 ? { xs: '0%', md: '12%' } : 0;
            
            return (
              <ServiceItem key={service.id} sx={{ 
                mt: index === 0 ? itemPosition : 0, 
                mb: { xs: 3, md: 5 }
              }}>
                {/* Number Circle with animation */}
                <NumberCircle
                  initial="hidden"
                  animate={(isInView && circleAnimationComplete) ? "visible" : "hidden"}
                  variants={numberCircleVariants}
                  custom={index}
                  onAnimationComplete={() => handleNumbersAnimationComplete(index)}
                >
                  {service.id}
                </NumberCircle>
                
                {/* Service Bar with animation */}
                <ServiceBar 
                  initial="hidden"
                  animate={(isInView && numbersAnimationComplete) ? "visible" : "hidden"}
                  variants={serviceBarVariants}
                  custom={index}
                  sx={{ ml: -2 }}
                >
                  <Typography>{service.text}</Typography>
                </ServiceBar>
              </ServiceItem>
            );
          })}
        </Box>
      </Box>
    </Container>
  );
};

export default DessertationProofReading;